import type {Theme} from '@emotion/react';

import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  count: number;
  className?: string;
  backgroundColor?: keyof Theme['colors'];
};

export const CountBadge = styled(({count, className}: Props) => {
  if (count <= 0) {
    return null;
  }
  return <span className={className}>{count}</span>;
})(
  ({theme, backgroundColor = 'interactionSecondary'}) => css`
    /** special font case */
    font: 700 0.6875rem/1rem ${theme.fontFamily};
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    align-self: flex-start;
    height: 18px;
    min-width: 18px;
    border-radius: 16px;
    color: ${theme.colors.contentInversePrimary};
    background: ${theme.colors[backgroundColor]};
    /**
     * no identical padding for left/right so that numbers appear rendered in center
     * when both have the same value it looks not quite right
     */
    padding: 0 4px 0 4px;

    ${theme.isAccessibleTheme &&
    css`
      border: 2px solid ${theme.colors.contentInversePrimary};
      box-shadow: 0 0 0 1px ${theme.colors[backgroundColor]};
    `}
  `
);
